import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_RS.json';
import exercises from './YOGA_EXERCISES_RS.json';
import recipes from './YOGA_RECIPES_RS.json';

export const YOGA_DATA_RS: ServiceData = {
  articles,
  exercises,
  recipes,
};
